export const prepareJSONFromStr = (str) => (
  str
    ? JSON.stringify(JSON.parse(str), null, '\t')
    : ''
);

export const minifyJSONFromStr = (jsonStr) => (
  jsonStr
    ? JSON.stringify(JSON.parse(jsonStr), null, '')
    : null
);
